import React from "react";
import ClinicLineChart from "./ClinicAnalytics/ClinicLineChart";
import { FaEllipsis } from "react-icons/fa6";
import { CiCalendar, CiTimer } from "react-icons/ci";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";

const ClinicOverview = ({ appointments, isLoading, isSuccess,monthlyOverview }) => {
  const navigate = useNavigate();

  // Always render chart
  return (
    <div className="max-md:space-y-4 md:grid md:gap-4 md:grid-cols-2 lg:grid-cols-7">
      {/* Chart */}
      <div className="rounded-lg text-black lg:col-span-4">
        <ClinicLineChart monthlyOverview={monthlyOverview}/>
      </div>

      {/* Right Panel (Appointments) */}
      <div className="rounded-lg border bg-white text-black shadow-sm lg:col-span-3 p-6">
        <h2 className="text-xl xl:text-1xl font-semibold leading-tight mb-2 tracking-tight">
          Recent Appointments
        </h2>

        {/* Loading state */}
        {isLoading && (
          <>
            <p className="text-sm text-gray-500 mb-4">Loading appointments...</p>
            <div className="space-y-3">
              {Array(3)
                .fill(0)
                .map((_, idx) => (
                  <div
                    key={idx}
                    className="h-16 bg-gray-100 rounded-md animate-pulse"
                  />
                ))}
            </div>
          </>
        )}

        {/* Empty state */}
        {!isLoading && (!isSuccess || !appointments?.length) && (
          <p className="text-sm text-gray-500 text-center mt-4">
            No recent appointments found
          </p>
        )}

        {/* Success state */}
        {isSuccess && appointments?.length > 0 && (
          <div className="mt-4 space-y-4">
            {appointments.slice(0, 3).map((appt, idx) => {
            const avatar =
  appt.gender?.toLowerCase() === "female"
    ? "/Images/woman.png"
    : "/Images/man.png";

              return (
                <div
                  key={appt.appointmentID || idx}
                  className="flex items-center justify-between flex-wrap gap-3 rounded-md border p-2 md:p-4"
                >
                  <div className="flex items-center space-x-4">
                    <span className="relative flex h-10 w-10 shrink-0 overflow-hidden rounded-full bg-gray-200">
                      <img
                        src={avatar}
                        alt={appt.gender}
                        className="h-10 w-10 object-cover rounded-full"
                      />
                    </span>
                    <div>
                      <p className="text-sm font-medium leading-none mb-1">
                        {appt.patientName}
                      </p>
                      <p className="text-sm text-gray-500">{appt.doctorName}</p>
                      <div className="flex items-center pt-1 gap-2 flex-wrap">
                        <div className="flex items-center sm:gap-1 text-xs text-gray-500">
                          <CiCalendar />
                          {dayjs(appt.appointmentDate).format("DD-MMM-YYYY")}
                        </div>
                        <div className="flex items-center sm:gap-1 text-xs text-gray-500">
                          <CiTimer /> {appt.timeSlot}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex items-center gap-2">
                    <div
                      className={`inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-semibold ${
                        appt.status === "Confirmed"
                          ? "border-green-500 text-green-500"
                          : appt.status === "Cancelled"
                          ? "border-red-500 text-red-500"
                          : appt.status === "Upcoming"
                          ? "border-blue-500 text-blue-500"
                          : "border-gray-400 text-gray-400"
                      }`}
                    >
                      {appt.status}
                    </div>
                    <button className="inline-flex items-center justify-center rounded-md hover:bg-gray-200 size-9">
                      <FaEllipsis className="h-4 w-4" />
                    </button>
                  </div>
                </div>
              );
            })}

            <button
              onClick={() => navigate("/clinic/appointments")}
              className="inline-flex items-center justify-center w-full h-9 gap-2 text-sm font-medium text-primary hover:underline underline-offset-4 rounded-md px-3"
            >
              View all appointments
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ClinicOverview;
